// Gallery Categories Mapping
// Maps folder names to translation keys and metadata

export const galleryCategories = {
  'ceremonie-ouverture-garoua-5': {
    titleKey: 'gallery.categories.ceremonie-ouverture-garoua-5.title',
    descriptionKey: 'gallery.categories.ceremonie-ouverture-garoua-5.description',
    order: 1
  },
  // Add more categories here as you create new folders
  // Example:
  // 'another-event-folder': {
  //   titleKey: 'gallery.categories.another-event-folder.title',
  //   descriptionKey: 'gallery.categories.another-event-folder.description',
  //   order: 2
  // }
};

// Helper function to get category info with translation function
export const getCategoryInfo = (folderName, t = null) => {
  const categoryConfig = galleryCategories[folderName];
  
  if (categoryConfig && t) {
    return {
      title: t(categoryConfig.titleKey),
      description: t(categoryConfig.descriptionKey),
      order: categoryConfig.order
    };
  } else if (categoryConfig) {
    // Fallback for when translation function is not available
    return {
      title: categoryConfig.titleKey,
      description: categoryConfig.descriptionKey,
      order: categoryConfig.order
    };
  } else {
    // Fallback for unmapped categories
    return {
      title: folderName.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      description: 'Gallery collection',
      order: 999
    };
  }
};